import { Injectable } from '@angular/core';
import { UserLoginRequestModel, UserLoginResponseModel } from '../models/authen.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private loginUserAPIUrl: string;
  private logoutUserAPIUrl: string;
  private forgetPasswordAPIUrl: string;


  constructor(private tokenService: TokenService, private httpClient: HttpClient) { }

  public login( user: UserLoginRequestModel): Observable<any> {
    this.loginUserAPIUrl = `${environment.dangkykhoatu_api}${environment.loginUser}`;
    return this.httpClient.post<UserLoginResponseModel>(this.loginUserAPIUrl, user).pipe(
      map((response: UserLoginResponseModel) => {
          if(response){                
            this.tokenService.setToken(response.accessToken); 
            this.tokenService.setUserData(response.user);      
            this.tokenService.setUserPermissions(response);     
          }   
          return response;          
      })
    ); 
  }
     
  public forgetPassword( user: any): Observable<any> {
      this.forgetPasswordAPIUrl = `${environment.dangkykhoatu_api}${environment.forgetPassword}`;
      return this.httpClient.post<UserLoginResponseModel>(this.forgetPasswordAPIUrl, { username: user }).pipe(
        map((response: any) => {
            return response;          
        })
      ); 
  }

  
  public logout() {
    const headers  = new HttpHeaders({
      'Content-Type': 'application/json',
       Authorization: `Bearer ${this.tokenService.getToken()}`
    });
    this.logoutUserAPIUrl = `${environment.dangkykhoatu_api}${environment.logoutUser}`;
    const body = {
      refreshToken: `${this.tokenService.getToken()}` 
    };
    return this.httpClient.post(this.logoutUserAPIUrl, body , { headers }).pipe(
        map((response) => {     
          if (response) {
            this.tokenService.removeToken(); 
            this.tokenService.removeUserData();
            this.tokenService.removeUserPermissions();
          }  
          return response;          
        })
    ); 
  }
}
